export default {
      id: "chevron-down-usage",
      viewBox: "0 0 11.908 6.308",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#chevron-down",
      toString: function () {
        return this.url;
      }
    }